import { render, staticRenderFns } from "./JumpingGameFinish.vue?vue&type=template&id=70acf661&scoped=true&"
import script from "./JumpingGameFinish.vue?vue&type=script&lang=js&"
export * from "./JumpingGameFinish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70acf661",
  null
  
)

export default component.exports